import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

import Utils from 'src/app/utils';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-outofhours',
  templateUrl: './outofhours.component.html',
  styleUrls: ['./outofhours.component.scss']
})
export class OutofhoursComponent implements OnInit {

  outofhours: any;

  alert_times = Utils.getAlertTimes();
  day_hours = Utils.getDayHours();

  formGroup = new FormGroup({
    mon_start: new FormControl('',[]),
    tue_start: new FormControl('',[]),
    wed_start: new FormControl('',[]),
    thu_start: new FormControl('',[]),
    fri_start: new FormControl('',[]),
    sat_start: new FormControl('',[]),
    sun_start: new FormControl('',[]),
    mon_end: new FormControl('',[]),
    tue_end: new FormControl('',[]),
    wed_end: new FormControl('',[]),
    thu_end: new FormControl('',[]),
    fri_end: new FormControl('',[]),
    sat_end: new FormControl('',[]),
    sun_end: new FormControl('',[]),
    monitors: new FormControl('',[]),
    alert_loop: new FormControl('',[])
  });

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    Utils.setupPopover();
    this.getOutOfHours();

  }

  getOutOfHours(){

    this.okService.get("outofhours",[])
    .subscribe((data) => {

      this.outofhours = data.body;

      //console.log("getOutOfHours", this.outofhours);

      this.setForm();

    });

  }

  setForm(){
    this.formGroup.setValue({
      mon_start: (this.outofhours.hours.mon_start ? this.outofhours.hours.mon_start : ''),
      tue_start: (this.outofhours.hours.tue_start ? this.outofhours.hours.tue_start : ''),
      wed_start: (this.outofhours.hours.wed_start ? this.outofhours.hours.wed_start : ''),
      thu_start: (this.outofhours.hours.thu_start ? this.outofhours.hours.thu_start : ''),
      fri_start:(this.outofhours.hours.fri_start ? this.outofhours.hours.fri_start : ''),
      sat_start:(this.outofhours.hours.sat_start ? this.outofhours.hours.sat_start : ''),
      sun_start:(this.outofhours.hours.sun_start ? this.outofhours.hours.sun_start : ''),
      mon_end: (this.outofhours.hours.mon_end ? this.outofhours.hours.mon_end : ''),
      tue_end: (this.outofhours.hours.tue_end ? this.outofhours.hours.tue_end : ''),
      wed_end: (this.outofhours.hours.wed_end ? this.outofhours.hours.wed_end : ''),
      thu_end: (this.outofhours.hours.thu_end ? this.outofhours.hours.thu_end : ''),
      fri_end: (this.outofhours.hours.fri_end ? this.outofhours.hours.fri_end : ''),
      sat_end: (this.outofhours.hours.sat_end ? this.outofhours.hours.sat_end : ''),
      sun_end: (this.outofhours.hours.sun_end ? this.outofhours.hours.sun_end : ''),
      monitors: this.outofhours.monitors,
      alert_loop: this.outofhours.alert_loop
    });

    this.setupMonitorLimit();

  }

  submitForm(){
    this.submitted = true;
    if(this.formGroup.valid)
    {
      let values = this.formGroup.value;
      //console.log('values',values);

      let body = {hours:values,monitors:values.monitors,alert_loop:values.alert_loop}

      this.okService.put('outofhours',body)
      .subscribe((data) => {

        this.getOutOfHours();

        //console.log('submit outofhours',this.outofhours);

        this.okService.setAlert(this.transloco.translate('The Out of Hours Alerts have been updated'),'success');

      });

    }

    return false;

  }

  toggleEnabled(outofhours:any){

    outofhours.on = + !outofhours.on;

    this.okService.put('outofhours',{'on':outofhours.on})
    .subscribe((data) => {
      //console.log("toggle on",data)

      this.getOutOfHours();

      if(outofhours.on){
        this.okService.setAlert(this.transloco.translate('The Out of Hours Alerts have been activated'),'success');
      }else{
        this.okService.setAlert(this.transloco.translate('The Out of Hours Alerts have been disabled'),'success');
      }



      }

    );


  }

  // If monitors number is equal to or less than 4 set a validator limit of 4
  // If monitors is 4 or greater then put an alert mentioning that 4 is the preferred limit
  setupMonitorLimit(){

    if(!this.okService.isFromAdmin()){

      let numOfMonitors = this.outofhours.monitors.length;

      if(numOfMonitors < 5){
        this.formGroup.get('monitors')!.addValidators(Validators.maxLength(4));
      }

    }


  }

}
